export default {"src":"/_next/static/media/pustack_logo.2b974d13.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};